<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}
.image_right {
  padding-bottom: 40px;
}




</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Magiun #2</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Hybrid publication, web development, illustration, food writing</p>
        <p>
          Magiun is a magazine about everyday food. It publishes stories, poems, essays, recipes, photos and illustrations.</p>
        <p>
          The <a href="https://magiun.alicestrete.me/secondissue">second issue</a> is about adapting - as a coping mechanism, a way of learning or a creative way of moving forward. The contributions were sent in early 2021. The illustration on the cover shows one way of adapting, regrowing and coping with anxiety, by planting the ends of spring onions in an old can of olives to have a steady supply of greens. It's based on true facts.</p>
          <p>The print publication was developed in collaboration with Simon Browne and printed by <a href="http://www.printroom.org/">Printroom Rotterdam</a>.</p>




      </div>
      </b-col>
      <b-col md="8">
        <b-row class="image_right">
          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/magiun2/window_small.png"></b-img>

          </b-col>
        </b-row>
        <b-row class="image_right">

          <b-col md="8" offset-md="2">
            <b-img class="img-fluid" src="media/magiun2/stack_small.png"></b-img>

          </b-col>
        </b-row>
        <b-row class="image_right">
      <b-col md="8" offset-md="2">
        <b-img class="img-fluid" src="media/magiun2/centerfold.png"></b-img>

      </b-col>
    </b-row>

    </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'Magiun2',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
